<form
  [formGroup]="passwordEmailForm"
  name="passwordEmailForm"
  (ngSubmit)="passwordEmailForm.valid && forgotPasswordSendEmailId()"
>
  <div class="group-email">
    <div *ngFor="let input of inputs" class="">
      <mapfre-validation
        [input]="input"
        [form]="passwordEmailForm"
      ></mapfre-validation>
    </div>
  </div>
  <div class="row text-center margin-top mt24">
    <div class="col">
      <mapfre-button
        [ngClass]="{ custom_loader: loader }"
        [additionalClasses]="'basic primary large-btn'"
        [disabledValue]="passwordEmailForm.valid && !loader"
        [inputType]="'submit'"
        [translateValue]="'CONTINUE' | translate"
      ></mapfre-button>
    </div>
  </div>
</form>
<div class="row text-center margin-top mt24">
  <div class="col">
    <ng-container
      *ngIf="whereInTheProcess === 'profilepassword/:emailPrefill'; else login"
    >
            <mapfre-button
        additionalClasses="link-button small red-link no-margin button-border-red"
        [backIcon]="'assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        (click)="onGoBck()"
        [showIconsCustom]="true"
      >
        {{ "BACK" | translate }}
      </mapfre-button>
    </ng-container>
    <ng-template #login>
      <ng-container *ngIf="!isAcmic; else loginwithborder">
        <mapfre-button
          additionalClasses="link-button small warn-ghost font-size-16 red-link button-border-login no-margin"
          [routerLink]="['/login']"
        >
          {{ "LOGIN" | translate }}
        </mapfre-button>
      </ng-container>
      <ng-template #loginwithborder>
      <mapfre-button
        additionalClasses="link-button small red-link no-margin"
        [backIcon]="'assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        [routerLink]="['/login']"
        [showIconsCustom]="true"
      >
        {{ "LOGIN" | translate }}
      </mapfre-button>
    </ng-template>
  </ng-template>
  </div>
</div>
